import { render, staticRenderFns } from "./FormTemplateAdd.vue?vue&type=template&id=6f1f0cd4&scoped=true&"
import script from "./FormTemplateAdd.vue?vue&type=script&lang=js&"
export * from "./FormTemplateAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1f0cd4",
  null
  
)

export default component.exports